import { Dispatch } from "redux";
import { createNotification as doCreateNotification } from "../redux/reducers";

const DEFAULT_AUTO_CLOSE_TIME = 6000;

const createNotification =
  (
    message: string,
    color: string,
    autoClose?: number,
    seeMoreContent?: () => JSX.Element
  ) =>
  (dispatch: Dispatch) =>
    doCreateNotification(message, color, autoClose, seeMoreContent)(dispatch);

export const createSuccessNotification =
  (message: string, autoClose: number = DEFAULT_AUTO_CLOSE_TIME) =>
  (dispatch: Dispatch) =>
    createNotification(message, "success", autoClose)(dispatch);

export const createErrorNotification =
  (message: string, autoClose: number = DEFAULT_AUTO_CLOSE_TIME) =>
  (dispatch: Dispatch) =>
    createNotification(message, "alert", autoClose)(dispatch);

export const createWarningNotification =
  (
    message: string,
    autoClose: number = DEFAULT_AUTO_CLOSE_TIME,
    seeMoreContent?: () => JSX.Element
  ) =>
  (dispatch: Dispatch) =>
    createNotification(message, "warning", autoClose, seeMoreContent)(dispatch);
